// eslint-disable-next-line
export const addActionButtonBar = actionButton => ({ type: 'ADD_ACTION_BUTTON_BAR', payload: actionButton });
